import React, { Component } from 'react';
import PropTypes from "prop-types";
import {BeatLoader} from 'react-spinners';
import Modal from 'react-modal';
import {get, post,postResponse} from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import {_addNotificationError, buildGradeName,getMonthNameByNumber, _addNotification} from "../../../server/util";
import $ from 'jquery';
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class ImportCertification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            invalidStudentIds:[],
            InvalidProcessTypeStudentsIds:[],
            responseMessage:'',
            step: 1,             
            previewData: [],
            adverseActionData:[],
            adverseActionCount:0,
            uploadedFile: null,
            matchedStudentCount:0,
            unmatchedStudentCount:0,
            conformationModalIsOpen:false
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
  
   handleSubmit = (e) => {
    e.preventDefault();

    const fileInput = document.getElementById('mealFile');
        if (!fileInput || !fileInput.files[0]) {
            _addNotificationError("Please select a valid file.", this);
            return;
        }
    const file = fileInput.files[0];
    const data = new FormData();
    data.append('file', file);
    
    //validation for upload file
    let validExts = [".xlsx", ".xls", ".csv"];
        if (!validExts.some(ext => file.name.endsWith(ext))) {
            _addNotificationError("Invalid file format. Please select valid file format (" + validExts.toString() + ")", this);
            return;
        }
    
    const fileSize = file.size;
    const fileMb = fileSize / 1024 ** 2;
        if (fileMb >= 2) {
            _addNotificationError("Please select a file less than 2MB.", this);
            return;
        }
    
    this.setState({ loading: true, uploadedFile: file });

    postResponse(
        '/importCertificationPreview?schoolId=' + sessionStorage.getItem("SchoolId") +
        "&schoolYear=" + sessionStorage.getItem('schoolYearValue') +
        '&type=' + this.state.type + '&isDistrictId=false&access_token=',data ).then(response => {
            if (response.statusCode!=200) {
                    throw Error(response.statusMessage);
                }
            return response;
         }).then(data => {
            console.log(data)
            let invalidIds=data.response.unmatchedStudentIds||[]
            let invalidTypeIds=data.response.MissingCertDateStds||[]
            invalidIds=(invalidIds||'').length>0?invalidIds:[];
            invalidTypeIds=(invalidTypeIds||'').length>0?invalidTypeIds:[];

            if(invalidIds.length>0 ||invalidTypeIds.length>0 ){
                this.setState({
                    alertModalIsOpen:true,
                    loading:false,
                    previewData: data.response.previewRows || [], 
                    adverseActionData:data.response.AdverseActionStudents||[],
                    adverseActionCount:data.response.AdverseActionCount|| 0,
                    unmatchedStudentCount: data.response.unmatchedStudentCount || 0, 
                    matchedStudentCount: data.response.matchedStudentCount || 0,
                    step: 2,
                    invalidStudentIds:invalidIds,
                    InvalidProcessTypeStudentsIds:invalidTypeIds,
                    responseMessage:data.statusMessage
                });
            }else{

                this.setState({
                    alertModalIsOpen:false,
                    loading:false,
                    previewData: data.response.previewRows || [], 
                    adverseActionData:data.response.AdverseActionStudents||[],
                    adverseActionCount:data.response.AdverseActionCount|| 0,
                    unmatchedStudentCount: data.response.unmatchedStudentCount || 0, 
                    matchedStudentCount: data.response.matchedStudentCount || 0,
                    step: 2,
                    invalidStudentIds:[],
                    InvalidProcessTypeStudentsIds:[],
                    responseMessage:data.statusMessage
                });
                _addNotification(data.statusMessage, this)
            }
    })
    .catch(err => {
        this.setState({ loading: false });
        _addNotificationError(err.message, this);
    });
};

handlePrevious = () => {
    this.setState({ step: 1 });
    const fileInput = document.getElementById('mealFile');
    if (fileInput) {
        fileInput.value = '';
    }
};

handleCancel = () => {
    this.setState({
        step: 1,
        previewData: [],
        adverseActionData:[],
    });
};

handleConfirm = () => {
    const { uploadedFile } = this.state;
    if (!uploadedFile) {
        _addNotificationError("File not found. Please upload again.", this);
        return;
    }

    const data = new FormData();
    data.append('file', uploadedFile); // ✅ reuse file

    this.setState({ loading: true });

    postResponse(
        '/importCertification?schoolId=' + sessionStorage.getItem("SchoolId") +
        "&isDistrictId=false&schoolYear=" + sessionStorage.getItem('schoolYearValue') +
        '&type=' + this.state.type + '&access_token=',
        data
    )
    .then(response => {
        if (response.statusCode!=200) {
                throw Error(response.statusMessage);
            }
            return response;
        }).then(data => {
                this.setState({
                    loading: false,
                    step: 1,
                    previewData: [],
                    uploadedFile: null, // ✅ reset
                });

        _addNotification(data.statusMessage , this);
    })
    .catch(err => {
        this.setState({ loading: false });
        _addNotificationError(err.message, this);
    });
};

render() {
        return (
            <section className="full-width clearfix">
                <div className="container">
                    <NotificationSystem ref="notificationSystem"/>
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="sectionTitle">
                                <h2>
                                    <span></span>
                                </h2>
                            </div>
                        </div>
                    </div>
                 {this.state.step === 1 && (   <div className="row">
                    <div className="row">
                        <form onSubmit={(e) => this.handleSubmit(e)}>
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center createmenu-panel">
                                <div className="panel panel-primary">
                                    <div className="panel-heading text-center">
                                        <h3 className="panel-title"> {'Direct Certification Import'}</h3>
                                    </div>
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                                    <label className="control-label"> Import Direct Certification Data </label>
                                                </div>
                                                
                                                <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">
                                                    <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">
                                                        <input type="file" className="form-control"
                                                                            style={{opacity: '1', zIndex: '0'}}
                                                                            id="mealFile" aria-describedby="basic-addon21"
                                                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"                                                                       
                                                                            onChange={(e) => {
                                                                                const file = e.target.files[0];
                                                                                if (!file) return;
                                                                                let validExts = [".xlsx", ".xls", ".csv"]; // ✅ added csv
                                                                                let fileName = file.name;
                                                                                let fileExt = "." + fileName.split('.').pop().toLowerCase();

                                                                                const fileSize = file.size;
                                                                                const fileMb = fileSize / 1024 ** 2;

                                                                                if (!validExts.includes(fileExt)) {
                                                                                    _addNotificationError(
                                                                                        "Invalid file format. Please select valid file format (" + validExts.toString() + ")",
                                                                                        this
                                                                                    );
                                                                                    e.target.value = '';
                                                                                    return false;
                                                                                } else if (fileMb >= 2) {
                                                                                    _addNotificationError("Please select a file less than 2MB.", this);
                                                                                    e.target.value = '';
                                                                                    return false;
                                                                                }
                                                                                this.setState({ uploadedFile: file });
                                                                                return true;
                                                                            }}
                                                                            />
                                                                        <button id="OpenUpload"
                                                                                className="input-group-addon" onClick={() => {
                                                                            $('#mealFile').click()
                                                                        }}><i
                                                                            className="fa fa-upload"
                                                                            aria-hidden="true"/>
                                                                        </button>
                                                                    </div>
                                                
                                                                </div>
                                                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                                                    <p className="input-group col-md-12 col-sm-12 col-xs-12">Upload student Certification data. Download&nbsp;<a
                                                                        href="https://mealmanage-prod.s3.amazonaws.com/SampleFiles/CertificationDateImport.xlsx"
                                                                        download>Sample file</a>
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-7 col-md-offset-3 text-center">
                                                                    <button type="submit" id="submit" className="btn btn-sm btn-primary"><i
                                                                        className="fa fa-arrow-circle-right"></i><span>Proceed</span></button>
                                                                </div>                        
                                                            </div>                    
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                       </div>
                 )}
            {this.state.step === 2 && (
                <div>
                    <h4 className="text-center">Preview Matched Students</h4>
                    <h5 className="text-right">Matched Student Count: {this.state.matchedStudentCount}</h5>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Student ID</th>
                                <th>Student Name</th>
                                <th>Date of Direct Certification</th>
                                <th>Assistance Program</th>
                            </tr>
                        </thead>
                    <tbody>
                            {this.state.previewData.length > 0 ? (
                                this.state.previewData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.studentSIS || '-'}</td>
                                        <td>{item.studentName || '-'}</td>
                                        <td>{item.dateOfDirectCertification || '-'}</td>
                                        <td>{item.programSource || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {/* if there are any adverse action students, show them in a separate table with confirm button to notify parent/guardian about the change in student benefit status */}
                  {this.state.adverseActionData.length > 0 && (
                    <div>
                    <hr />
                    
                    <h4 className="text-center">Advere Action Students</h4>
                    <h5 className="text-right">Adverse Action Count: {this.state.adverseActionCount}</h5>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Student ID</th>
                                <th>Student RecID</th>
                                <th>Student Name</th>
                                <th>Current Status</th>
                                <th>Previous Status</th>
                            </tr>
                        </thead>
                    <tbody>
                            {this.state.adverseActionData.length > 0 ? (
                                this.state.adverseActionData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.studentId || '-'}</td>
                                        <td>{item.studentRecId || '-'}</td>
                                        <td>{item.studentName || '-'}</td>
                                        <td>{item.currentStatus || '-'}</td>
                                        <td>{item.previousStatus || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    </div> 
                  ) }
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>  
                    {/* Left side */}
                    <button className="btn btn-info" onClick={this.handlePrevious}>
                        Previous
                    </button>
                    {/* Right side */}
                    <div>
                        <button className="btn btn-success" 
                        onClick={() => {
                                    if ((this.state.adverseActionData || []).length > 0) {
                                        this.setState({ conformationModalIsOpen: true });
                                    } else {
                                        this.handleConfirm();
                                    }
                                }}
                         >
                            Confirm
                        </button>

                        <button className="btn btn-danger" onClick={this.handleCancel} style={{ marginLeft: '10px' }}>
                            Cancel
                        </button>
                    </div>
                    </div>
            </div>
            )}
            </div>  
            {
              this.state.invalidStudentIds.length>0 || this.state.InvalidProcessTypeStudentsIds.length>0?
                <Modal isOpen={this.state.alertModalIsOpen} style={modalStyles}
                       onRequestClose={() => this.setState({alertModalIsOpen:false})} >
                <div className="modal-body">
                    <div className="row">
                        {
                            <div className="col-md-12 col-sm-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="color-5 text-center" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                        }}>
                                        <strong>
                                            {
                                                this.state.responseMessage
                                            }
                                        </strong>
                                        </p>
                                    </div>
                                </div>
                                { this.state.invalidStudentIds.length>0 &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="color-1" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                        }}> <strong>Note:</strong> These below student id's does not exists in MealManage. Please check and make sure that you are passing valid students.</p>
                                        <span style={{color:'red', textDecoration:'underline'}} >Invalid Student Id's:</span> <span className="pull-right">Count:{this.state.unmatchedStudentCount}</span>
                                        <div className="row" style={{overflowY:'scroll', height:'150px'}}>
                                        { this.state.invalidStudentIds.map((item, index)=>{
                                                return (<div className="col-md-4" key={index}><i className="fa fa-hand-o-right"></i> { item}</div>)
                                            })
                                        }
                                        </div>
                                    </div>
                                </div> }
                                { this.state.InvalidProcessTypeStudentsIds.length>0 &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="color-1" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                        }}> <strong>Note:</strong> These below student id's do not have a valid Date of Direct Certification in the uploaded file. Please check and make sure that a certification date is provided for these students.</p>
                                        <span style={{color:'red', textDecoration:'underline'}} >Missing Certification Date Student Id's:</span> <span className="pull-right">Count:{this.state.InvalidProcessTypeStudentsIds.length}</span>
                                        <div className="row" style={{overflowY:'scroll', height:'150px'}}>
                                        { this.state.InvalidProcessTypeStudentsIds.map((item, index)=>{
                                                let studentId = (item && typeof item === 'object')?(item.studentSIS || item.studentId || '-'):item;
                                                return (<div className="col-md-4" key={index}><i className="fa fa-hand-o-right"></i> { studentId}</div>)
                                            })
                                        }
                                        </div>
                                    </div>
                                </div> }
                            </div>
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="text-right">
                        <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                    this.setState({alertModalIsOpen:false})
                                }}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                        </button>
                    </div>
                </div>
            </Modal>:null } 

            <Modal
                    isOpen={this.state.conformationModalIsOpen}
                    onRequestClose={() => this.setState({ conformationModalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Confirmation">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="conformationLabel">Confirmation</h4>
                    </div>
                    <div className="modal-body">
                        <p>These students meet the criteria for Adverse Action. 
                            Parents/Guardians will be notified of the downgrade for the following students. 
                            They will continue to receive their original benefits for the next 10 operating days. 
                            If the parent/guardian files an appeal, update the status for the student under Claims Reports → Adverse Action.</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-sm"
                            onClick={() => this.setState({ conformationModalIsOpen: false })}
                            style={{ margin: 0, fontSize: 14 }}> Cancel
                        </button>
                        <button id="confirmEligibilityChange" type="button" className="btn btn-success btn-sm"
                            onClick={() => {
                                    this.setState(
                                        { conformationModalIsOpen: false },
                                        () => this.handleConfirm()
                                    );
                                }}
                            style={{ margin: 0, marginLeft: 5, fontSize: 14 }}>
                            Confirm</button>
                    </div>
                </Modal>        
            </section>
        );
    }
}
ImportCertification.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ImportCertification;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ImportCertification/index.jsx